import { Route } from "@angular/router";
import { componentCanNavigateGuard } from "../_shared/guards/component-can-navigate.guard";
import { Federations } from "../organisation/models/federation";
import { SubscriptionTypeEnum } from "../organisation/models/subscription";

export const PersonsPaths = {
  Overview: "overzicht",
  OverviewWithWorkYear: (workYearId: number | string) => `overzicht/${workYearId}`,
  OverviewZwemfed: "overzichtZwemfed",
  OverviewZwemfedWithWorkYear: (workYearId: number | string) => `overzichtZwemfed/${workYearId}`,
  VotasMembers: (votasId: number | string) => `votasleden/${votasId}`,
  Import: "importeren",
  IntrestCheck: "interesses/check",
  EditInterests: (personId: number | string) => `bewerken/${personId}/interesses`,
  Edit: (personId: number | string) => `bewerken/${personId}`,
  EditWithWorkYear: (personId: number | string, workingyearId: number | string) =>
    `bewerken/${personId}/${workingyearId}`,
  Add: "toevoegen",
  Skills: "vaardigheden",
  AddSkill: "vaardigheden/toevoegen",
  EditSkill: (skillId: number | string) => `vaardigheden/bewerken/${skillId}`,
  MergeDuplicates: "dubbele-samenvoegen",
};

export const PersonEditPaths = {
  Person: "details",
  Member: "lid",
  Volunteer: "vrijwilliger",
  Participant: "deelnemer",
  VZF: "vzf",
  Federation: "federatie",
};

export default [
  {
    path: "",
    redirectTo: PersonsPaths.Overview,
    pathMatch: "full",
  },
  {
    path: PersonsPaths.OverviewWithWorkYear(":workYear"),
    loadComponent: () =>
      import("./pages/person-list/person-list.component").then((c) => c.PersonListComponent),
    data: {
      breadcrumb: "Leden beheren",
      title: "Leden beheren",
      subscriptionTypes: [1],
    },
  },
  {
    path: PersonsPaths.Overview,
    loadComponent: () =>
      import("./pages/person-list/person-list.component").then((c) => c.PersonListComponent),
    data: {
      breadcrumb: "Overzicht",
      title: "Personen",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: PersonsPaths.OverviewZwemfed,
    loadComponent: () =>
      import("./pages/zwemfed-list/zwemfed-list.component").then((c) => c.ZwemfedListComponent),
    data: {
      breadcrumb: "Leden beheren",
      title: "Leden beheren",
      subscriptionTypes: [1],
    },
  },
  {
    path: PersonsPaths.OverviewZwemfedWithWorkYear(":workYear"),
    loadComponent: () =>
      import("./pages/zwemfed-list/zwemfed-list.component").then((c) => c.ZwemfedListComponent),
    data: {
      breadcrumb: "Leden beheren",
      title: "Leden beheren",
      subscriptionTypes: [1],
    },
  },
  {
    path: PersonsPaths.VotasMembers(":votas"),
    loadComponent: () =>
      import("./pages/zwemfed-list/zwemfed-list.component").then((c) => c.ZwemfedListComponent),
    data: {
      breadcrumb: "VOTAS-leden beheren",
      title: "VOTAS-leden beheren",
      subscriptionTypes: [1],
    },
  },
  {
    path: PersonsPaths.Import,
    loadComponent: () =>
      import("./pages/person-import/person-import.component").then((c) => c.PersonImportComponent),
    data: {
      breadcrumb: "Personen importeren",
      title: "Personen importeren",
      subscriptionTypes: [1],
    },
  },
  {
    path: PersonsPaths.IntrestCheck,
    loadComponent: () =>
      import("./pages/intrest-check/intrest-check.component").then((c) => c.IntrestCheckComponent),
    data: {
      breadcrumb: "Polsen naar interesses",
      title: "Polsen naar interesses",
      subscriptionTypes: [1],
    },
  },
  {
    path: PersonsPaths.EditInterests(":id"),
    loadComponent: () =>
      import("./pages/person-intrest-edit/person-intrest-edit.component").then(
        (c) => c.PersonIntrestEditComponent
      ),
    data: {
      breadcrumb: "Interesses bewerken",
      title: "Interesses bewerken",
      subscriptionTypes: [1],
    },
  },
  {
    path: PersonsPaths.Edit(":id"),
    loadComponent: () =>
      import("./pages/person-edit/person-edit.component").then((c) => c.PersonEditComponent),
    data: {
      breadcrumb: "Persoon bewerken",
      title: "Persoon bewerken",
      subscriptionTypes: [1, 4],
      federations: [Federations.Vlamo],
    },
    children: [
      { path: "", redirectTo: PersonEditPaths.Person, pathMatch: "full" },
      {
        path: PersonEditPaths.Person,
        loadComponent: () =>
          import("./pages/person-edit/person-edit-details/person-edit-details.component").then(
            (c) => c.PersonEditDetailsComponent
          ),
        data: {
          breadcrumb: "Persoonsgegevens",
          title: "Persoonsgegevens",
        },
        canDeactivate: [componentCanNavigateGuard],
      },
      {
        path: PersonEditPaths.Member,
        loadComponent: () =>
          import("./pages/person-edit/person-edit-member/person-edit-member.component").then(
            (c) => c.PersonEditMemberComponent
          ),
        data: {
          breadcrumb: "Lidmaatschap",
          title: "Lidmaatschap",
        },
        canDeactivate: [componentCanNavigateGuard],
      },
      {
        path: PersonEditPaths.VZF,
        loadComponent: () =>
          import("./pages/person-edit/person-edit-vzf/person-edit-vzf.component").then(
            (c) => c.PersonEditVZFComponent
          ),
        data: {
          breadcrumb: "Zwemfed",
          title: "Info Zwemfed",
        },
        canDeactivate: [componentCanNavigateGuard],
      },
      {
        path: PersonEditPaths.Volunteer,
        loadComponent: () =>
          import("./pages/person-edit/person-edit-volunteer/person-edit-volunteer.component").then(
            (c) => c.PersonEditVolunteerComponent
          ),
        data: {
          breadcrumb: "Vrijwilliger",
          title: "Vrijwilliger",
        },
      },
      {
        path: PersonEditPaths.Federation,
        loadComponent: () =>
          import("./pages/person-edit/person-edit-fed/person-edit-fed.component").then(
            (c) => c.PersonEditFedComponent
          ),
        data: {
          breadcrumb: "Producten",
          title: "Producten",
        },
      },
    ],
  },
  {
    path: PersonsPaths.EditWithWorkYear(":id", ":workingYearId"),
    loadComponent: () =>
      import("./pages/person-edit/person-edit.component").then((c) => c.PersonEditComponent),
    data: {
      breadcrumb: "Lid bewerken",
      title: "Lid bewerken",
    },
  },
  {
    path: PersonsPaths.Add,
    loadComponent: () =>
      import("./pages/person-edit/person-edit.component").then((c) => c.PersonEditComponent),
    data: {
      breadcrumb: "Persoon toevoegen",
      title: "Nieuwe persoon toevoegen",
    },
  },
  {
    path: PersonsPaths.Skills,
    loadComponent: () =>
      import("./pages/skill/skill-list/skill-list.component").then((c) => c.SkillListComponent),
    data: {
      breadcrumb: "Vaardigheden",
      title: "Vaardigheden",
      subscriptionTypes: [1],
    },
  },
  {
    path: PersonsPaths.AddSkill,
    loadComponent: () =>
      import("./pages/skill/skill-edit/skill-edit.component").then((c) => c.SkillEditComponent),
    data: {
      breadcrumb: "Vaardigheid toevoegen",
      title: "Vaardigheid toevoegen",
      subscriptionTypes: [1],
    },
  },
  {
    path: PersonsPaths.EditSkill(":id"),
    loadComponent: () =>
      import("./pages/skill/skill-edit/skill-edit.component").then((c) => c.SkillEditComponent),
    data: {
      breadcrumb: "Vaardigheid aanpassen",
      title: "Vaardigheid aanpassen",
      subscriptionTypes: [1],
    },
  },
  {
    path: PersonsPaths.MergeDuplicates,
    loadComponent: () =>
      import("../menu/pages/on-hold/on-hold.component").then((c) => c.OnHoldComponent),
    data: {
      breadcrumb: "Dubbele personen",
      title: "Dubbele personsen samenvoegen",
      subscriptionTypes: [SubscriptionTypeEnum.Plus],
      previousVersionUrl: "https://app.assistonline.eu/dba/#/app/personen/samenvoegen",
    },
  },
] satisfies Route[];
